import captcha from './captcha'
import cellphone from './cellphone'
import check from './check'
import qr from './qr'
import status from './status'

export default {
  cellphone,
  check,
  qr,
  status,
  captcha
}
